import { create } from 'zustand';

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
}

interface PwaState {
  deferredPrompt: BeforeInstallPromptEvent | null;
  setPrompt: (e: BeforeInstallPromptEvent) => void;
}

export const usePwaStore = create<PwaState>((set) => ({
  deferredPrompt: null,
  setPrompt: (e) => set({ deferredPrompt: e }),
}));
